// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nezW","content":"styles_content__2S4wg","selectAll":"styles_selectAll__29Cwh"};